export default __webpack_public_path__ + "static/media/014-bomb-detonation.a29c38e8.png";